import { render, staticRenderFns } from "./ResultsListItem.vue?vue&type=template&id=fdc18056"
import script from "./ResultsListItem.vue?vue&type=script&lang=js"
export * from "./ResultsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports